import calculations from 'assets/icons/PPSIcons/calculations.svg';
import detailedSchedule from 'assets/icons/PPSIcons/detailedSchedule.svg';
import jobTags from 'assets/icons/PPSIcons/jobTags.svg';
import ppsTool from 'assets/icons/PPSIcons/ppsTool.svg';
import referenceTable from 'assets/icons/PPSIcons/referenceTable.svg';
import releasingPriorityList from 'assets/icons/PPSIcons/releasingPriorityList.svg';
import scheduleAttainment from 'assets/icons/PPSIcons/scheduleAttainment.svg';
import stagingPriority from 'assets/icons/PPSIcons/stagingPriority.svg';
import standardTimeLegend from 'assets/icons/PPSIcons/standardTimeLegend.svg';
import visibilityBoard from 'assets/icons/PPSIcons/visibilityBoard.svg';
import hsPriority from 'assets/icons/PPSIcons/hsPriority.svg';

export const screenHeadersData = [
  {
    navbarHeading: 'PPS Scheduling Tool Enhancement',
    screenName: 'PPS Scheduling Tool Enhancement',
    icon: ppsTool,
    route: '/job-paste',
    disabled: false
  },
  {
    navbarHeading: 'Reference',
    screenName: 'Reference Tables',
    icon: referenceTable,
    route: '/reference',
    disabled: false
  },
  {
    navbarHeading: 'Calculations',
    screenName: 'Calculations',
    icon: calculations,
    route: '/calculations',
    disabled: false
  },
  {
    navbarHeading: 'Staging Priority List',
    screenName: 'Staging Priority List',
    icon: stagingPriority,
    route: '/staging-priority-list',
    disabled: false
  },
  {
    navbarHeading: 'Job Tags',
    screenName: 'Job Tags',
    icon: jobTags,
    route: '/job-tags',
    disabled: false
  },

  {
    navbarHeading: 'Detailed Schedule',
    screenName: 'Detailed Schedule',
    icon: detailedSchedule,
    route: '/detailed-schedule',
    disabled: false
  },
  {
    navbarHeading: 'Visibility Board',
    screenName: 'Visibility Board',
    icon: visibilityBoard,
    route: '/visibility-board',
    disabled: false
  },
  {
    navbarHeading: 'Schedule Attainment',
    screenName: 'Schedule Attainment',
    icon: scheduleAttainment,
    route: '/schedule-attainment',
    disabled: false
  },

  {
    navbarHeading: 'Releasing Priority List',
    screenName: 'Releasing Priority List',
    icon: releasingPriorityList,
    route: '/releasing-priority-list',
    disabled: false
  },
  {
    navbarHeading: 'Standard Time Legend',
    screenName: 'Standard Time Legend',
    icon: standardTimeLegend,
    route: '/standard-time-legend',
    disabled: false
  },
  {
    navbarHeading: 'Room Schedule',
    screenName: 'Room Schedule',
    icon: hsPriority,
    route: '/hs-room-priorities',
    disabled: false
  }
];
